import { render, staticRenderFns } from "./Reader.vue?vue&type=template&id=4e0bfb06&scoped=true"
import script from "./Reader.vue?vue&type=script&lang=js"
export * from "./Reader.vue?vue&type=script&lang=js"
import style0 from "./Reader.vue?vue&type=style&index=0&id=4e0bfb06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0bfb06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e0bfb06')) {
      api.createRecord('4e0bfb06', component.options)
    } else {
      api.reload('4e0bfb06', component.options)
    }
    module.hot.accept("./Reader.vue?vue&type=template&id=4e0bfb06&scoped=true", function () {
      api.rerender('4e0bfb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/plot/Reader.vue"
export default component.exports